/* eslint-disable @typescript-eslint/no-explicit-any */
var _a;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: Need to have dot-access for the webpack define plugin to work
export const isProduction = (_a = process.env.NODE_ENV === 'production') !== null && _a !== void 0 ? _a : true;
export const devMode = !isProduction || /\bdevconsole\b/.test(window.location.search + window.location.hash);
/**
 * Creates a logger with the given bound arguments.
 */
function createLogger(impl, ...defaultArgs) {
    function log(type, ...args) {
        impl[type](...defaultArgs, ...args);
    }
    const logger = log.bind(null, 'info');
    logger.log = logger;
    logger.error = log.bind(null, 'error');
    logger.warn = log.bind(null, 'warn');
    logger.info = log.bind(null, 'info');
    logger.debug = log.bind(null, 'debug');
    return logger;
}
function noop() {
    // Do nothing
}
const NULL_LOGGER = createLogger({
    debug: noop,
    error: noop,
    info: noop,
    log: noop,
    warn: noop,
});
/**
 * Creates a logger with the given bound arguments but will return no-op loggers unless in dev mode.
 */
export const loggerFor = devMode ? createLogger.bind(null, console) : () => NULL_LOGGER;
